import './AgentHome.css';
import { forwardRef, useRef, useState } from 'react';
import { Loading } from '@icp/components';
import { selectUserProfile } from 'store/features/authSlice';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import GeneralAIAgent from '../../GeneralAIAgent';

const Step = {
  WELCOME: 'WELCOME',
  INITIAL: 'INITIAL',
};

const LandingPageAI = forwardRef((props, ref) => {
  const { t } = useTranslation(['icp-components']);

  const [step, setStep] = useState(Step.WELCOME);
  const userProfile = useSelector(selectUserProfile);
  const generalAgentRef = useRef();
  const [currentAgent, setCurrentAgent] = useState(null);

  const handleNewChatStarted = () => {
    setStep(Step.WELCOME);
  };

  const onMessageSent = () => {
    setStep(Step.INITIAL);
  };

  return userProfile ? (
    <div
      className={`landing-page-ai ${step === Step.WELCOME ? 'welcome-style' : 'initial-style'}`}
      ref={ref}
    >
      <div className="landing-page-ai-welcome">
        <div className="landing-page-ai-welcome-container">
          {step === Step.WELCOME && (
            <div className="landing-page-ai-welcome-main">
              <div className="landing-page-ai-welcome-greeting">
                <div className="landing-page-ai-welcome-greeting-title">
                  {t('agent-home.welcome.greeting', { name: currentAgent?.name })}
                </div>
                <div className="landing-page-ai-welcome-greeting-subtitle">
                  {t('agent-home.welcome.subtitle')}
                </div>
              </div>
            </div>
          )}
          <div className="agent">
            <GeneralAIAgent
              ref={generalAgentRef}
              suppressFloatButton={true}
              onAgentChanged={setCurrentAgent}
              eventHandlers={{
                onNewChatStarted: handleNewChatStarted,
                onMessageSent,
              }}
              agentListConfiguration={{ defaultFirstAgent: true }}
            />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Loading />
  );
});

export default LandingPageAI;
